import { SnackbarProvider, MaterialDesignContent } from 'notistack';
import { Box, IconButton, styled } from '@mui/material';

import { removeNotification } from 'helper/notifications';
import { useHeaderHeight } from 'hooks/useHeaderHeight';
import { CrossIcon as CloseIcon } from 'assets/icons';

const StyledNotification = styled(MaterialDesignContent)(({ theme: { palette, breakpoints, typography } }) => ({
  ...typography['subtitle1-bold'],
  borderRadius: '20px',
  flexWrap: 'nowrap',
  [breakpoints.up('sm')]: {
    width: 470,
  },
  '.MuiButtonBase-root': {
    width: 24,
    height: 24,
    padding: 'unset',
    backgroundColor: `${palette.common.white} !important`,
    [breakpoints.up('md')]: {
      width: 32,
      height: 32,
    },
    svg: {
      width: 12,
      height: 12,
    },
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: palette.success.main,
    '.MuiButtonBase-root svg': {
      color: palette.success.main,
    },
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: palette.error.main,
    '.MuiButtonBase-root svg': {
      color: palette.error.main,
    },
  },
}));

const styles = {
  notificationsWrapper: ({ breakpoints }, headerHeight) => ({
    '.notistack-SnackbarContainer': {
      top: headerHeight + 8,
      [breakpoints.up('md')]: {
        top: headerHeight + 24,
      },
    },
  }),
};

export const Notifications = () => {
  const { headerHeight } = useHeaderHeight();

  return (
    <Box sx={(theme) => styles.notificationsWrapper(theme, headerHeight)}>
      <SnackbarProvider
        hideIconVariant
        maxSnack={3}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        Components={{
          success: StyledNotification,
          error: StyledNotification,
        }}
        action={(toastId) => (
          <IconButton onClick={() => removeNotification(toastId)}>
            <CloseIcon />
          </IconButton>
        )}
      />
    </Box>
  );
};
